module.exports = __webpack_public_path__ + "img/team-01.886c5b36.jpg";